import { CalendarTextIcon } from './CalendarTextIcon';

/**
 * author: Google
 * id 1A873476-B82D-4E23-BF19-897F0A0C0B93
 * name calendar-text
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-text.svg
 * tags
 * - Date / Time 
 */
export const EventTextIcon = CalendarTextIcon;
export default EventTextIcon